import { Component, OnInit } from '@angular/core';
import {CoefService} from '../../service/coef.service';

@Component({
  selector: 'app-two-door-clock',
  templateUrl: './two-door-clock.component.html',
  styleUrls: ['./two-door-clock.component.scss']
})
export class TwoDoorClockComponent implements OnInit {

  constructor(public coef: CoefService) { }

  ngOnInit() {
  }

}
